import MuiCircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import React from 'react';

const CircularProgress = (props) => {
  return <MuiCircularProgress {...props}></MuiCircularProgress>;
};

CircularProgress.propTypes = {
  children: PropTypes.node,
};

export default CircularProgress;
